module.exports = __webpack_public_path__ + "img/playera_1.50453e25.png";